document.addEventListener("DOMContentLoaded", function() {
  /* ===== Circular progress rings — small, thin, loading-style ===== */
  var RADIUS = 18;
  var CIRCUMFERENCE = 2 * Math.PI * RADIUS;

  function animateCircle(el) {
    var target = parseInt(el.getAttribute("data-target"), 10);
    var max = parseInt(el.getAttribute("data-max") || "100", 10);
    var progress = target / max;
    var circle = el.querySelector(".stat-circle__progress");
    var valueEl = el.querySelector(".stat-circle__value");
    var suffix = "";

    if (valueEl) {
      var txt = valueEl.textContent.trim();
      suffix = txt.replace(target.toString(), "");
    }

    if (!circle) return;

    circle.style.strokeDasharray = CIRCUMFERENCE;
    circle.style.strokeDashoffset = CIRCUMFERENCE;

    var duration = 2000;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var p = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      circle.style.strokeDashoffset = CIRCUMFERENCE * (1 - eased * progress);

      if (valueEl) {
        valueEl.textContent = Math.floor(eased * target) + suffix;
      }

      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var circles = document.querySelectorAll("[data-circle]");
  if (!circles.length) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateCircle(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  circles.forEach(function(el) { observer.observe(el); });
});
